import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MeetingResponse } from 'src/app/models/basicMeetingModel';
import { AttendeeService } from 'src/app/service/attendee.service';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { FreeFormCommonService } from 'src/app/service/free-form-common.service';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { PermissionService } from 'src/app/service/permission.service';
import { UtilityService } from 'src/app/service/utility.service';
import { environment } from 'src/environments/environment';
declare var $: any;
@Component({
  selector: 'app-agenda-edit-dialog',
  templateUrl: './agenda-edit-dialog.component.html',
  styleUrls: ['./agenda-edit-dialog.component.css']
})
export class AgendaEditDialogComponent implements OnInit {
  @ViewChild('name') inputName: any;
  meetingResponse !: MeetingResponse
  agendaList: any;
  agendaPresenterList: any = [];
  newPresenter: any;
  newArrayContainer :any = [];
  newPresenterList: any=[];
  constructor(private utilService:UtilityService,private permissionService:PermissionService,public commonAgService: FreeFormAgendaService, private attendeeService: AttendeeService, private matDialogRef: MatDialogRef<AgendaEditDialogComponent>, private globals: Globals, @Inject(MAT_DIALOG_DATA) data: any, private meetingService: MeetingService,private commonService:FreeFormCommonService) {
    
    
    this.agendaList = data.agenda;
    this.meetingResponse = data.meetingres;
    this.setData();
    this.newPresenterList.pop();
  }

  agendaEditBox = new UntypedFormGroup({
    agendaTitle: new UntypedFormControl(''),
    agendaId: new UntypedFormControl(''),
    agendaDuration: new UntypedFormControl(''),
    agendaPresenterList: new UntypedFormControl(''),
    agendaDesc: new UntypedFormControl(''),
    defaultNotes: new UntypedFormControl(''),
    userId: new UntypedFormControl(''),
    meetingId: new UntypedFormControl(''),
  });

  setData() {
    this.agendaList.agendaPresenterList.forEach((presenter: any) => {
      var presenterJsonList = {
        "presenterUserId": presenter.presenterUserId,
        "presenterName": presenter.presenterName
      }
      this.agendaPresenterList.push(presenterJsonList)
    });
//this.agendaEditBox.controls['agendaTitle'].setValue(this.agendaList.agendaTitle);

this.agendaEditBox.controls['agendaTitle'].setValue(this.commonService.trimNoteDesc($("#meetAgendaId"+this.agendaList.agendaId), 'AG', ''));
    this.agendaEditBox.controls['agendaId'].setValue(this.agendaList.agendaId);
    this.agendaEditBox.controls['agendaDuration'].setValue(this.agendaList.agendaDuration);
    this.agendaEditBox.controls['agendaPresenterList'].setValue(this.agendaPresenterList);
    this.agendaEditBox.controls['agendaDesc'].setValue(this.agendaList.agendaDesc);
    this.agendaEditBox.controls['defaultNotes'].setValue(this.agendaList.defaultNotes);
    this.agendaEditBox.controls['userId'].setValue(this.globals.userId);
    this.agendaEditBox.controls['meetingId'].setValue(this.agendaList.meetingId);

  }

  updateAgendaEditBox() {

    var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilService.featureList.AGENDA,this.utilService.permissionType.MODIFY);
    
    if(!roleFlag){
      return;
    }
    this.newPresenterList.forEach((presenter: any) => {
      var presenterJsonList = {
        "presenterUserId": presenter.userId,
        "presenterName": presenter.userName,
      }
      this.agendaPresenterList.push(presenterJsonList);
    });
    ////consolee.log('this.agendaPresenterList=',this.agendaPresenterList);
    this.agendaEditBox.controls['agendaPresenterList'].setValue(this.agendaPresenterList);
    ////consolee.log("agenda value from edit box", this.agendaEditBox.value);
     
   this.commonAgService.updateAgendaEditbox(this.agendaEditBox.value,this.agendaList.agendaId).then((req:any) => {    
    this.matDialogRef.close(req);
   });
   
    
  }
  ngOnInit(): void {
  }

  loadPresenter(obj: any, id : any) {
    ////consolee.log('inside loadPresenter from popup');

    var assignedTo: any;
    return new Promise((resolve, reject) => {
    this.attendeeService.loadAttendeeAgendaPresenter(true, 'AGEDIT', obj)
    .then(($inputor: any) => {
      var pageIns = this;
      $inputor.off("inserted.atwho");
      $inputor.on("inserted.atwho", function (event: any, $li: any, query: any) {
        if ($li.length != 0) {
        
            $('.atwho-inserted:first', obj);
            $('.atwho-inserted:first', obj).before("<span class='presentedByCls' contentEditable='false'>, </span>");
            assignedTo = {
              "userId": $li.data('item-data').id,
              "userName": $li.data('item-data').value,
            }
            resolve(assignedTo);
            let addAttendeejsonobj = {
              "attendeeName": $li.data('item-data').value,
              "attendeeEmail": $li.data('item-data').email,
               "fkCodelstAttendeeRole": 9,
               "attendeeIsPresent": environment.AttendeeIsPresent,
              "attendeeId": "",
              "fkSecUserAttendee": $li.data('item-data').id,
               "attendeeRole": "Attendee",
              "createdBy": 0,
              "attendeeRoleCode": environment.defAttendeeRoleCode,
              "logType":"IN",
              "deletedFlag": 0,
              "availableStatus":"",
              "meetingId":pageIns.meetingResponse.meetingId,
              "isJoined":""
          }
          
          var fkuserIdVal:any = []
          pageIns.meetingResponse.attendeeList?.forEach((attendees:any)=>{
            var x = attendees.fkSecUserAttendee;
            var y: number =+x;
            fkuserIdVal.push(y);
            
  
            });
            var a = addAttendeejsonobj.fkSecUserAttendee;
            var b:number = +a;
            if(fkuserIdVal.includes(b) == false){
              
  
            pageIns.attendeeService.addAttendee(addAttendeejsonobj).subscribe((data:any)=>{
            
            var attObj = addAttendeejsonobj;
            attObj["attendeeId"] = data.attendeeId;
            attObj["fkCodelstAttendeeRole"] = data.fkCodelstAttendeeRole;
            attObj["attendeeIsPresent"] = data.attendeeIsPresent;
            attObj["attendeeRole"] = data.attendeeRole;
            attObj["createdBy"] = data.createdBy;
            attObj["deletedFlag"] = data.deletedFlag;
            attObj["logType"] = "IN";
            attObj["isJoined"] ="";
            pageIns.meetingResponse.attendeeList?.push(attObj);
            
               
             });
            }
        }
      })
    })
  }).then((respVal:any)=>{
    ////consolee.log('respVal=',respVal);
    this.newPresenterList.push(respVal);
  });

    // this.newArrayContainer.push(obj.value);

    this.inputName.nativeElement.value = ' ';
  }
  trigger(event : any, id : any){
    // //
    
    // //
    // (document.getElementById(id)as HTMLElement).nodeValue = null;
    // $('#'+id).html('')
    // //
    //   presenterUserId: '',
    //   presenterName: 'Eleven'
    // }))
  //  //
    let targetValue = event.target.value;
    if(targetValue){
    //  //
      if(targetValue != ' '){
        this.newArrayContainer.push(targetValue);
      }

      ////consolee.log("newArrayContainer",this.newArrayContainer)
      ////consolee.log("array container",new Array(event.target.value))
      // $("#"+id).empty();
      this.inputName.nativeElement.value = ' ';
    }
    // else{
    //   window.alert("called")
    // }
    // else{

    // }
  //   var presenterList = this.commonAgService.agendaPresenter();
  //   if(presenterList != undefined){
  //   //
  //   this.agendaList.agendaPresenterList.forEach((presenter: any) => {
  //     var presenterUserId: number = +presenterList.userId;
  //     var presenterJsonList = {
  //       "presenterUserId": presenterUserId,
  //       "presenterName": presenterList.userName,
  //     }
  //     this.agendaPresenterList.push(presenterJsonList);
  //   });
  // }
  //   this.agendaEditBox.controls['agendaPresenterList'].setValue(this.agendaPresenterList);
  //   //
     
  //   this.commonAgService.updateAgendaEditbox(this.agendaEditBox.value,this.agendaList.agendaId);
   
  //   this.matDialogRef.close();
  }

  removePresentee(indexNumber : any,obj:any){
   // //
    ////consolee.log('before slice ',this.newArrayContainer,this.newPresenterList);
    this.newArrayContainer.splice(indexNumber, 1)
    this.newPresenterList.forEach((agElem: any, agIndex: any) => {
      if(obj.presenterName==agElem.presenterName){
        this.newPresenterList.pop();
      }
    });
  }

  removePresenteeJson(indexNumber : any,obj:any){
    ////consolee.log('removing old',obj);
    this.agendaList.agendaPresenterList.splice(indexNumber,1)
    //this.agendaPresenterList.slice(indexNumber);
    this.agendaPresenterList.forEach((agElem: any, agIndex: any) => {
      if(obj.presenterName==agElem.presenterName){
        this.agendaPresenterList.pop();
      }

    });
    ////consolee.log('after slice ',this.agendaPresenterList,this.agendaPresenterList.lenth);
  }

  numberOnly(event:any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  
}
